<form class="filters" (ngSubmit)="apply()" [attr.aria-busy]="loading">
  <label class="search-filter">
    Function or URL
    <span class="search-input">
      <i class="pi pi-search" aria-hidden="true"></i>
      <input type="search" name="search" [(ngModel)]="draft.search" placeholder="Search function or URL">
    </span>
  </label>
  <label>
    Service
    <select name="source" [(ngModel)]="draft.source">
      <option value="">All services</option>
      <option *ngFor="let source of sources" [ngValue]="source">{{ source }}</option>
    </select>
  </label>
  <label>
    Function type
    <select name="functionType" [(ngModel)]="draft.functionType">
      <option value="">All types</option>
      <option *ngFor="let type of functionTypes" [ngValue]="type">{{ type }}</option>
    </select>
  </label>
  <label>
    Trigger
    <select name="triggerSource" [(ngModel)]="draft.triggerSource">
      <option value="">All triggers</option>
      <option *ngFor="let trigger of triggerSources" [ngValue]="trigger">{{ trigger }}</option>
    </select>
  </label>
  <label>
    Status
    <select name="status" [(ngModel)]="draft.status">
      <option value="">All statuses</option>
      <option *ngFor="let status of statuses" [ngValue]="status">{{ status }}</option>
    </select>
  </label>
  <label>Queued from<input type="date" name="fromDate" [(ngModel)]="draft.fromDate"></label>
  <label>Queued to<input type="date" name="toDate" [(ngModel)]="draft.toDate"></label>
  <div class="actions">
    <button type="button" [disabled]="loading" (click)="clear()">Clear</button>
    <button type="submit" class="primary" [disabled]="loading">
      <i class="pi pi-filter" aria-hidden="true"></i> Apply
    </button>
  </div>
</form>
